<template>
    <div>
        <draggable v-if="listTestimonial.length != 0"
            class="list-group border-bottom mb-5"
            tag="ul"
            v-model="listTestimonial"
            v-bind="dragOptions"
            @start="isDragging = true"
            @end="isDragging = false">
            <transition-group type="transition" name="flip-list" class="d-flex align-items-start">
            <li class="card list-group-item p-0 mb-5 ml-3 mr-3" v-for="element in listTestimonial" :key="element.id">
                <div class="card-header fw-500 text-white bg-primary-500 bg-info-gradient d-flex align-items-center flex-wrap p-3">
                    <div class="card-title">{{element.title}}</div>
                    <div class="d-flex ml-auto">
                        <a class="link" @click="deleteTestimonial(element)">
                            <i class="fas fa-trash"></i>
                        </a>
                    </div>
                </div>
                <i :class="element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'" @click="element.fixed = !element.fixed" aria-hidden="true"></i>
                <img class="card-img-top" :src="getImage(element.path)">
                <div class="card-body">
                    <p class="card-text">{{element.details}}</p>
                    <a v-if="element.video != ''" class="link float-right text-primary mb-3" :href="element.video" target="_blank">More Information</a>
                </div>
            </li>
            </transition-group>
        </draggable>
        <form @submit.prevent="addTestimonial">
            <h6 class="fw-500 mb-1">{{$t('header.add') + $t('outlet_setting.info.header_testimonial')}}</h6>
            <div class="row">
                <div class="col-lg-6 col-xl-6 p-3 border-right">
                    <div class="form-group">
                        <label class="form-label">{{$t('label.title')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-text" ></i>
                                </span>
                            </div>
                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.title')" v-model="title">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{$t('label.details')}}</label>
                        <textarea class="form-control" :placeholder="$t('label.details')" rows="8" v-model="details"></textarea>
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{$t('label.url', {'item': $t('label.video')})}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-video" ></i>
                                </span>
                            </div>
                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.url', {'item': $t('label.video')})" v-model="video">
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-xl-6 p-3">
                    <div><label class="form-label">{{$t('label.image')}}</label></div>
                    <div class="mt-2"> 
                        <div v-if="image != ''" class="text-center mt-3">
                            <div class="text-right mb-2 mr-2">
                                <button v-if="dzShow" class="btn btn-sm btn-outline-primary" type="button" :title="$t('button_link.delete') + $t('label.image')" @click="image =''">
                                    <span class="fal fa-trash"></span>
                                </button>
                                <button v-else class="btn btn-sm btn-outline-primary" type="button" :title="$t('button_link.upload') + $t('label.image')" @click="dzShow = true">
                                    <span class="fal fa-cloud-upload-alt" ></span>
                                </button>
                            </div>
                            <img class="img-fluid img-thumbnail" :src="image"/>
                        </div>
                        <div v-else>
                            <vue-dropzone ref="dropzone" class="text-center" id="dropLogo" :options="dropOptions" @vdropzone-success="dropLogo"></vue-dropzone>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-left mb-5">
                <button type="submit" class="btn border-0 btn-dark btn-padding waves-effect waves-themed">{{$t('button_link.add')}}</button>
            </div>
        </form>
        <div class="text-left pt-5 mb-3 border-top">
            <button type="button" class="btn border-0 btn-primary btn-padding waves-effect waves-themed" @click="submitInfo">{{$t('button_link.save')}}</button>
        </div>
    </div>
</template>

<script>
import vueDropzone from "vue2-dropzone";
import draggable from "vuedraggable";
export default {
    name: 'testimonial',
    components:{
        vueDropzone, draggable
    },
    props:{
        testimonial: { type: Array }
    },
    computed:{
        dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    },
    data(){
        return{
            title: "", details: "", video: "",
            listTestimonial: [], image: "",
            dzShow: true,
            dropOptions: {
                url: this.$api.API_IMAGE,
                addRemoveLinks: true,
                maxFiles: 1,
                paramName: 'filename',
                headers:{
                    token: this.$util.getSessionToken()
                }
            },
        }
    },
    methods:{
        closeModal(){
            this.$parent.$parent.isModalShow = false
        },
        getImage(path){
            return path
        },
        deleteTestimonial(item){
            this.listTestimonial = this.listTestimonial.filter(obj=> obj.id != item.id)
        },
        dropLogo(file, response){
            if(response.path == undefined){
                this.parent.$parent.setModal(this, false, true, this.$msg.IMG_UPLOAD_ERROR);
            }else{
                this.image = response.path
            }
            this.$refs.dropzone.removeFile(file)
        },
        submitInfo(){
            var data = []
            for(var i=0; i<this.listTestimonial.length; i++){
                data.push({
                    testimonialDtls: this.listTestimonial[i].details,
                    testimonial: this.listTestimonial[i].title,
                    imgUrl: this.listTestimonial[i].path,
                    videoUrl: this.listTestimonial[i].video,
                })
            }
            this.$emit('submitInfo', {testimonial: data});
        },
        addTestimonial(){
            this.listTestimonial.push({
                order: this.listTestimonial.length + 1,
                id: 'testimonial_' + this.listTestimonial.length + 1,
                details: this.details,
                title: this.title,
                path: this.image,
                video: this.video,
            })
            this.resetForm()
            // this.$emit('submitInfo', data);
        },
        resetForm(){
            this.title = this.details = this.video = this.image = ""
        }  
    },
    mounted(){
        let $vm = this
        for(var i=0; i<$vm.testimonial.length; i++){
            $vm.listTestimonial.push({
                order: i,
                id: 'testimonial_' + i,
                details: $vm.testimonial[i].testimonialDtls,
                title: $vm.testimonial[i].testimonial,
                path: $vm.testimonial[i].imgUrl,
                video: $vm.testimonial[i].videoUrl,
            })
        }
    },
    
}
</script>
<style scoped>
.img-thumbnail{
    width: 18em;
}
.card{
    width: 25%;
}
.flip-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
.list-group {
    min-height: 20px;
}
.list-group-item {
    display: inline-block;
    cursor: move;
}
.list-group-item i {
    cursor: pointer;
}
</style>